import { Injectable, inject } from '@angular/core';

import { I18nService } from '@core/i18n-legacy';
import type { RatingLevelType } from '@core/interview-results-types';
import { NotificationsController } from '@core/user-interface-legacy';

export enum QuickEvalOperationType {
  ADD,
  UPDATE,
  DELETE,
}

@Injectable({ providedIn: 'root' })
export class QuickEvaluationNotificationService {
  private readonly i18n = inject(I18nService);
  private readonly notificationsCtrl = inject(NotificationsController);

  public success(data: { operationType: QuickEvalOperationType; rating?: RatingLevelType }): void {
    this.notificationsCtrl.success(this.getTranslations(data));
  }

  private getTranslations(data: {
    operationType: QuickEvalOperationType;
    rating?: RatingLevelType;
  }): {
    title: string;
    message: string;
  } {
    switch (data.operationType) {
      case QuickEvalOperationType.ADD:
        return {
          title: this.i18n.translate('app.interview.quick_evaluation_added.title'),
          message: data.rating
            ? this.i18n.translate('app.interview.quick_evaluation_added.message', {
                score: this.i18n.translate(`app.interview.summary.${data.rating}`),
                emoji: '', // TODO: Remove this property when it's deleted from all languages in Phrase
              })
            : '',
        };
      case QuickEvalOperationType.UPDATE:
        return {
          title: this.i18n.translate('app.candidate.evaluation_updated'),
          message: '',
        };
      case QuickEvalOperationType.DELETE:
        return {
          title: `${this.i18n.translate('app.candidate.evaluation_deleted')} 🗑️`,
          message: '',
        };
      default:
        return { title: '', message: '' };
    }
  }
}
